import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionThumbsUpIcon = (props: IconProps) => (
  <Icon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" fill="#E5F2FF" />
    <path
      fill="#007AFF"
      d="M6.222 24h3.556V13.334H6.222V24Zm19.556-9.777c0-.978-.8-1.778-1.778-1.778h-5.609l.845-4.062.026-.285c0-.364-.15-.702-.39-.942l-.943-.933-5.849 5.857c-.329.32-.524.765-.524 1.254v8.889c0 .977.8 1.777 1.777 1.777h8c.738 0 1.37-.444 1.636-1.084l2.684-6.267c.08-.204.125-.418.125-.649v-1.777Z"
    />
  </Icon>
);

export default memo(ReactionThumbsUpIcon);
